import { DomainEventPayload } from '../events/event.types';
import { EventLoopImpactMapping } from '../loop/event-loop.mapping';
import { FeedImpactUpdate } from './feed-impact-update.contract';
import { LifecycleEvaluationResult } from './lifecycle-evaluation.contract';
import { ScoreUpdateInput } from './score-update.contract';

/** Ordered stages of deterministic event processing. */
export type EventProcessingPipelineStage =
  | 'domain_event'
  | 'event_mapping'
  | 'score_update_input'
  | 'feed_impact_update'
  | 'lifecycle_evaluation';

/** Canonical pipeline flow — each stage consumes the prior stage output. */
export const EVENT_PROCESSING_PIPELINE_FLOW: readonly EventProcessingPipelineStage[] = [
  'domain_event',
  'event_mapping',
  'score_update_input',
  'feed_impact_update',
  'lifecycle_evaluation',
];

/** Structural definition of the event processing pipeline. */
export interface EventProcessingPipeline {
  readonly stages: typeof EVENT_PROCESSING_PIPELINE_FLOW;
}

export const EVENT_PROCESSING_PIPELINE: EventProcessingPipeline = {
  stages: EVENT_PROCESSING_PIPELINE_FLOW,
};

/**
 * Envelope moving through the pipeline.
 * Fields are populated stage-by-stage at runtime (execution not defined here).
 */
export interface EventProcessingPipelineEnvelope {
  domainEvent: DomainEventPayload;
  eventMapping: EventLoopImpactMapping | null;
  scoreUpdateInput: ScoreUpdateInput | null;
  feedImpactUpdate: FeedImpactUpdate | null;
  lifecycleEvaluation: LifecycleEvaluationResult | null;
}

/** Empty envelope for pipeline entry at stage `domain_event`. */
export function createPipelineEnvelope(domainEvent: DomainEventPayload): EventProcessingPipelineEnvelope {
  return {
    domainEvent,
    eventMapping: null,
    scoreUpdateInput: null,
    feedImpactUpdate: null,
    lifecycleEvaluation: null,
  };
}
